import React, { useRef, useState } from 'react';
import InlinePopoverCard from '../InlinePopoverCard/InlinePopoverCard';
import './UserStatus.scss';
import { Icon, ICONS } from 'components/Icons';
import UserStatusWithDetailsPopoverContent from '../UserStatusWithDetails/UserStatusWithDetailsPopoverContent';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { UserLevelGraphModal } from 'routes/Admin/components/Users/Users';
import { UserExtensionActionsHistoryModal } from 'components/elements/organisms/UserExtensionActionsHistory/UserExtensionActionsHistoryModal';

function UserStatus({
  user,
  username,
  currentUser,
  children,
  course,
  history,
  selectShowCourseDashboard,
  breadCrumb,
  setPortfolioBreadCrumb,
  updateUserProfile,
}) {
  const inlinePopoverCardRef = useRef(null);
  const [showUserLevelModal, setShowUserLevelModal] = useState(false);
  const [
    showUserExtensionActionHistoryModal,
    setShowUserExtensionActionHistoryModal,
  ] = useState(false);

  const handleModalClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowUserLevelModal(false);
  };

  const handleActionHistoryModalClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowUserExtensionActionHistoryModal(false);
  };

  const handlePopoverClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    inlinePopoverCardRef.current?.hide();
  };

  const renderUserLevelModal = () =>
    showUserLevelModal && (
      <div onClick={handleModalClose}>
        <UserLevelGraphModal username={username} onClose={handleModalClose} />
      </div>
    );

  const renderUserExtensionActionHistoryModal = () =>
    showUserExtensionActionHistoryModal && (
      <div>
        <UserExtensionActionsHistoryModal
          userId={user._id}
          onClose={handleActionHistoryModalClose}
        />
      </div>
    );

  const renderPopover = () => {
    if (!user) {
      return null;
    }

    return (
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <UserStatusWithDetailsPopoverContent
          user={user}
          currentUser={currentUser}
          course={course}
          history={history}
          selectShowCourseDashboard={selectShowCourseDashboard}
          setShowUserLevelModal={setShowUserLevelModal}
          setShowUserExtensionActionHistoryModal={
            setShowUserExtensionActionHistoryModal
          }
          breadCrumb={breadCrumb}
          setPortfolioBreadCrumb={setPortfolioBreadCrumb}
          updateUserProfile={updateUserProfile}
        />
        <button
          type="button"
          className="close-btn"
          onClick={handlePopoverClose}
        >
          <Icon icon={ICONS.CLOSE} size={10} className="close-icon" />
        </button>
      </div>
    );
  };

  return (
    <>
      <InlinePopoverCard
        overlay={renderPopover()}
        placement="right"
        ref={inlinePopoverCardRef}
      >
        {children}
      </InlinePopoverCard>
      {renderUserLevelModal()}
      {renderUserExtensionActionHistoryModal()}
    </>
  );
}

function mapStateToProps(state, ownProps) {
  const username =
    ownProps.user?.username ?? ownProps.username ?? state.user.user.username;
  return {
    user:
      state.user.user.username === username
        ? state.user.user
        : state.user.usersWithDetails.byUsername[username],
    username,
    currentUser: state.user.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
  selectShowCourseDashboard: (reportName, filters) => {
    dispatch(Actions.selectShowCourseDashboard(true, reportName, filters));
  },
  setPortfolioBreadCrumb(breadCrumb) {
    dispatch(Actions.updatePortfolioBreadCrumb(breadCrumb));
  },
  updateUserProfile(profile) {
    dispatch(Actions.updateUserProfile(profile));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserStatus),
);
